import { ValidatorFn, AbstractControl, AsyncValidatorFn, ValidationErrors, FormGroup } from '@angular/forms';
import { DataService } from 'src/app/services/data-api.service';
import { AppUser } from 'src/app/models/dbmodels';
import { Observable, of, catchError, map, distinctUntilChanged, first, startWith, switchMap } from 'rxjs';

export const ValidatorsHelper = {
  requiredIf: (otherControlName: string, conditionCallback: (value: any) => boolean): ValidatorFn => {
    return (control: AbstractControl) => {
      const otherControl = control?.parent?.get(otherControlName);
      if (!otherControl) {
        return null;
      }
      // Use the callback to determine whether the field should be required
      const shouldBeRequired = conditionCallback(otherControl.value);
      if (shouldBeRequired && !control.value) {
        return { requiredIf: true };
      }

      return null;
    };
  },
  isRequired: (control: AbstractControl, fieldName: string): boolean => {
    
    const form_field = control.get(fieldName);
        if (!form_field) {
    return false;} // control doesn't exist yet
    if(!form_field.validator) {
      return false;
    }

    // return the required state of the validator
    const validator = form_field.validator({} as AbstractControl);
    return validator && validator['required'];
  },

  validateEmailExists: (appUser: AppUser = {} as AppUser, dataService: DataService): AsyncValidatorFn => {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      const email = (control.value ?? '').trim();
      if (!email) return of(null);

      // If editing existing user and email hasn't changed, skip API
      const current = (appUser?.EmailAddress ?? '').trim();
      if (current && email.toLowerCase() === current.toLowerCase()) return of(null);

      return dataService.userExistsByEmail(email).pipe(
        map(exists => exists ? { emailExists: true } : null),
        catchError(() => of(null)) // important
      );
    };
  },

  isNotEqualTo(forbiddenValue: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isForbidden = control.value === forbiddenValue;
      return isForbidden ? { notEqualTo: { value: control.value } } : null;
    };
  },
  passwordMatchValidator(controlName: string, matchingControlName: string) : ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      
      const formGroup = control as FormGroup;
      const mainControl = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
  
      // If another validator has already found an error on the matchingControl, return early
      if (matchingControl.errors && !matchingControl.errors['passwordMismatch']) {
        return null;
      }
  
      // Set the 'mustMatch' error on matchingControl if validation fails
      if (mainControl.value !== matchingControl.value) {
        matchingControl.setErrors({ passwordMismatch: true })
        return { passwordMismatch: true };
      } else {
        matchingControl.setErrors(null)
        return null;
      }
    };
  },
  validateOldPassword(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) {
        return of(null);
      }

      return this.dataService.validatePassword(this.appUser.UserId, control.value).pipe(
        map(res => (!res ? { incorrectPassword: true } : null)),
        catchError(() => of(null))
      );
    };
  },
  productTypeExistsWithinSchedule(scheduleIdControlName : string, dataService : DataService): AsyncValidatorFn {
    return (ctrl: AbstractControl) => {
      return ctrl.valueChanges.pipe(
        startWith(ctrl.value),
        //debounceTime(500),
        distinctUntilChanged(),
        switchMap(value => {
          const parent = ctrl.parent;
          const scheduleId    = parent?.get(scheduleIdControlName)?.value;
          const productTypeId =  ctrl.value;
  
          if (!scheduleId || !productTypeId) {
            // nothing to validate yet
            return of<ValidationErrors | null>(null);
          }
  
          // return the actual HTTP check as an Observable
          return dataService
            .productTypeExistsWithinSchedule(scheduleId, productTypeId) // Observable<boolean>
            .pipe(
              map(exists =>
                exists
                  // if the service says “yes, that productType already exists in this schedule”
                  ? null
                  // otherwise validation passes
                  :  { productTypeDoesntExistsWithinSchedule: true }
              )
            );
        }),
        first() // complete after one emission so Angular knows the validator is done
      );
    };
}
  // performanceExistsWithinProductType(productTypeIdControlName: string, dataService: DataService): AsyncValidatorFn {

  // }

};
